import { motion } from 'framer-motion';

const ToggleIcon = () => {
  return (
    <motion.svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none'>
      <path
        d='M5.20833 10.4167C4.0625 10.4167 3.125 11.3542 3.125 12.5C3.125 13.6459 4.0625 14.5834 5.20833 14.5834C6.35417 14.5834 7.29167 13.6459 7.29167 12.5C7.29167 11.3542 6.35417 10.4167 5.20833 10.4167ZM19.7917 10.4167C18.6458 10.4167 17.7083 11.3542 17.7083 12.5C17.7083 13.6459 18.6458 14.5834 19.7917 14.5834C20.9375 14.5834 21.875 13.6459 21.875 12.5C21.875 11.3542 20.9375 10.4167 19.7917 10.4167ZM12.5 10.4167C11.3542 10.4167 10.4167 11.3542 10.4167 12.5C10.4167 13.6459 11.3542 14.5834 12.5 14.5834C13.6458 14.5834 14.5833 13.6459 14.5833 12.5C14.5833 11.3542 13.6458 10.4167 12.5 10.4167Z'
        fill='var(--pcm-body-action-color)'
      />
    </motion.svg>
  );
};

export default ToggleIcon;
